export const RowStatusesNamesMap = {
  READY_FOR_IMPORT: 'ready_for_import',
  ASK_CUSTOMER: 'ask_customer',
  NEEDS_CHANGE: 'needs_change',
  IGNORE: 'ignore',
  IMPORTED: 'imported',
  NOT_REVIEWED: 'not_reviewed',
  IGNORE_BY_CUSTOMER: 'ignore_by_customer',
  NEEDS_RE_REVIEW: 'needs_re_review',
  SUPPLY: 'supply',
  UNMATCHED: 'unmatched',
  CORRECT_BY_MULTIMATCH: 'correct_by_multimatch',
  ASIS: 'asis',
  NEEDS_CODE_CHANGE: 'needs_code_change',
  NO_MULTIMATCH: 'no_multimatch',
  COMPOUNDED: 'compounded',
  READY_FOR_RE_MATCH: 'ready_for_re_match',
  IMPORT_VERIFIED_BY_CUSTOMER: 'import_verified_by_customer',
  DO_NOT_IGNORE: 'do_not_ignore'
};
